import React, { useEffect, useState } from 'react';

import { Breadcrumb, css, IBreadcrumbItem, IBreadcrumbStyles, ITooltipHostProps, ITooltipHostStyles, mergeStyleSets, TooltipHost, TooltipOverflowMode } from '@fluentui/react';

import routes from "../../../routes";
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { RouteComponentProps } from 'react-router-dom';
import AppUtilities from '../../../shared/Utilities/appUtilities';
import Utilities from '../../../shared/Utilities/utilities';
import { Protocol_State } from '../../../shared/enums';


const bradcrumbStyles: Partial<IBreadcrumbStyles> = {
    root: {
        margin: '0',
        padding: '4px 14px',
        borderBottom: '1px solid #eee',
        '& .ms-Breadcrumb-listItem:first-of-type .ms-Breadcrumb-itemLink': {
            fontSize: '20px',
            fontWeight: 'normal'
        },
        '& .ms-Breadcrumb-listItem:first-of-type .ms-Breadcrumb-item': {
            fontSize: '20px',
            fontWeight: 'normal'
        }
    },
    item: {
        fontSize: '14px'
    },
    itemLink: {
        fontSize: '14px'
    },
};


export interface IBreadcrumbsProps {
}
type Props = IBreadcrumbsProps & RouteComponentProps


const Breadcrumbs: React.FunctionComponent<Props> = props => {

    const selectCurrentUor = (state: RootState) => state.sessionReducer.currentUor;
    const currentUor = useSelector(selectCurrentUor);

    const selectCurrentProtocol = (state: RootState) => state.appNavigationReducer.protocol;
    const currentProtocol = useSelector(selectCurrentProtocol);

    const selectCurrentFascicolo = (state: RootState) => state.appNavigationReducer.fascicolo;
    const currentFascicolo = useSelector(selectCurrentFascicolo);

    const [isParentTooltipVisible, setIsParentTooltipVisible] = useState(false);

    const hostStyles: Partial<ITooltipHostStyles> = {
        root: { display: 'block' },
    };
    const classNames = mergeStyleSets({
        // Applied to make content overflow (and tooltips activate)
        overflow: {
            display: 'block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            maxWidth: "480px",
        }
    });

    const tooltipHostProps: Partial<ITooltipHostProps> = {
        hostClassName: classNames.overflow,
        overflowMode: TooltipOverflowMode.Self
    }

    const onBreadcrumbsItemHandler = (ev, item) => {
        if (item && item.path)
            props.history.push({ pathname: item.path, search: props.location.search });

    }
    const getBreadcrumbText = (text: string | undefined) => {
        let breadcrumbText;
        if (text === ':uorSigla') {
            breadcrumbText = currentUor ? currentUor.nome! : undefined;
        }
        else if (text === ':protocolnumber' && currentProtocol && currentProtocol.numeroProtocollo && currentProtocol.annoProtocollo) {
            breadcrumbText = AppUtilities.FormatProtocolNumber(currentProtocol);
            let oggetto = currentProtocol.fields?.find(el => el.internalName === 'OggettoProtocollo')

            if (currentProtocol.fields && oggetto && oggetto.internalValue) {
                breadcrumbText += ' - ' + oggetto.internalValue;
            }
        }
        else if (text === ':protocolnumber') {
            // quando carica la pagina da zero currnetProtocol non ha numeroProtocollo e annoProtocollo valorizzati
            // quindi prendo il testo della briciola dal parametro :protocolnumber
            breadcrumbText = props.match.params[text.slice(1)].replace('-', '/');
        }
        else if (text === ':fascicoloId') {
            breadcrumbText = currentFascicolo ? currentFascicolo.fascicoloLabel: "";
        }
        else {
            breadcrumbText = text;
        }
        return Utilities.CapitalizeString(breadcrumbText);
    }


    const matchedRoutes = routes
        // Get all routes that contain the current one.
        .filter(({ path, text }) => text && props.match.path.includes(path)).sort(compareRouteLevel);

    const remapCrumbs = () => {
        let crumbs: any[] = [];
        matchedRoutes.forEach(({ path, text, key }, index) => {

            let newPath = Object.keys(props.match.params).length > 0
                ? Object.keys(props.match.params).reduce((path, param) => path?.replace(`:${param}`, props.match.params[param]), path)
                : path;

            let breadcrumbsText = getBreadcrumbText(text);
            if (breadcrumbsText) {
                crumbs.push({
                    path: newPath,
                    key: key,
                    text: breadcrumbsText,
                    onClick: matchedRoutes.length === index + 1 ? undefined : onBreadcrumbsItemHandler,
                    isCurrentItem: matchedRoutes.length === index + 1
                });
            }
        });

        return crumbs;
    }
    const [crumbs, setCrumbs] = useState<IBreadcrumbItem[]>(remapCrumbs);

    useEffect(() => {
        // creo IBreadcrumbItem[] a partire delle matchedRoutes
        setCrumbs(remapCrumbs);
    }, [currentUor, currentProtocol, currentFascicolo]);


    const overflowIndex = crumbs && crumbs.length > 1 ? 1 : 0;

    function onRenderBreadcrumbItem(item, defaultRender) {


        return <TooltipHost
            overflowMode={TooltipOverflowMode.Self}
            hostClassName={css(item.text.length > 20 && classNames.overflow)}
            content={item.text}
            onTooltipToggle={setIsParentTooltipVisible}
            styles={hostStyles}
        >
            {defaultRender(item)}
        </TooltipHost>
    }


    return (
        /// valutare su ha senso utilizzare il component CommandBar per gestire meglio overflow e tooltip
        <Breadcrumb
            items={crumbs}
            overflowIndex={overflowIndex}
            styles={bradcrumbStyles}
            tooltipHostProps={tooltipHostProps}
        />
    );
}

export default Breadcrumbs;

function compareRouteLevel(a, b) {
    if (a.routelevel < b.routelevel) {
        return -1;
    }
    else if (a.routelevel > b.routelevel) {
        return 1;
    }

    // a must be equal to b
    return 0;
}